import styled from "styled-components";

export const ChartBox = styled.div`
  width: 100%;
  height: ${(p) => p.$height || 320}px;
  padding: 16px 12px 8px;
`;

// Container for the generic KitTooltip (name / value rows).
// Class names are `tt-` prefixed on purpose: bare `.row`/`.dot` are claimed by
// the globally imported Bootstrap grid, whose `.row > *` rule forces gutter
// padding + width:100% on every child — that stretched the swatch into an oval
// and pushed each value onto its own line.
export const TooltipBox = styled.div`
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 11px;
  font-size: 12.5px;
  min-width: 150px;
  max-width: 320px;
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.12);

  .tt-hd {
    font-weight: 700;
    color: #1e293b;
    margin: 0 0 6px;
    padding-bottom: 5px;
    border-bottom: 1px solid #eef2f7;
  }
  .tt-row {
    display: flex;
    flex-wrap: nowrap;
    align-items: baseline;
    gap: 8px;
    margin: 0;
    padding: 2px 0;
  }
  .tt-sw {
    flex: 0 0 auto;
    width: 9px;
    height: 9px;
    padding: 0;
    margin: 0;
    border-radius: 2.5px;
    transform: translateY(-1px);
  }
  .tt-nm {
    flex: 1 1 auto;
    min-width: 0;
    padding: 0;
    color: #475569;
  }
  .tt-val {
    flex: 0 0 auto;
    margin-left: auto;
    padding: 0;
    font-weight: 700;
    color: #0f172a;
    font-family: "DM Mono", monospace;
    white-space: nowrap;
  }
  .tt-unit {
    margin-left: 3px;
    font-weight: 500;
    color: #94a3b8;
  }
`;

// PathwayChart tooltip — required / actual / on-track colour classes.
export const PathwayTip = styled.div`
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 9px 12px;
  font-size: 12.5px;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.1);
  .yr { font-weight: 700; color: #1e293b; margin-bottom: 3px; }
  .req { color: #3f88a5; }
  .act { color: #c0392b; }
  .plan { color: #7a6ba8; }
`;

// CategoryLinesChart tooltip — per-category rows are coloured inline.
export const CategoryTip = styled.div`
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 9px 12px;
  font-size: 12.5px;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.1);
  .yr { font-weight: 700; color: #1e293b; margin-bottom: 3px; }
`;
